import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Input, Cascader } from 'antd';
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun"
const FormItem = Form.Item;

import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'
import { StandardCode } from 'rt-sd-common/sgiFactory/StandardCode';
import { getConstByKey } from './sgiBaseComp/SgiCommon';

class SgiFormCascader extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);

        //初始化state属性
        this.initState();
        this.state.multiattribute = true;
        this.state.displayField = '';
        this.state.saveField = '';
        this.state.casData = []; //下拉框内容
        this.state.childrenName = "cldSet";
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule 
     * @param {组件描述} moduleDesc 
     * @param {绑定实例ID} bdInst 
     * @param {当前工作区} ws 
     * @param {make类型} type 
     */
    cascader_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        var moduleDesc = this.props.moduleDesc;
        if (!moduleDesc) {
            return;
        }
        //组装下拉框内容
        var casStore = this.fitSelectOption(moduleDesc);
        this.state.casData = casStore;
        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //转换form公共属性
        AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //设置布局
        setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
        //绑定值
        this.bindValue(this, moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
    }


    /**
   * 组装下拉框内容
   * @param {描述} moduleDesc 
   */
    fitSelectOption(moduleDesc) {

        // this.state.store = [];
        var tData;
        var scId = moduleDesc.scId; //绑定实例名
        if (scId) {
            // 下拉窗列表值在标准代码中的id
            tData = StandardCode.getSC(scId);
            this.state.displayField = 'te';
            this.state.saveField = 'c';
        } else {
            var insName = getConstByKey(this, moduleDesc.insName); //绑定实例名

            //取得绑定类名`  var tData = [];
            if (insName) {
                tData = objFct.get(insName);
            }
            this.state.displayField = moduleDesc.showKey;
            this.state.saveField = moduleDesc.saveKey;
        }
        if (!tData) {
            return [];
        }
        return tData;
    }

    /**
     * 属性转换
     * @param {描述信息} moduleDesc 
     * @param {属性} formItem 
     * @param {属性} inputprops 
     */
    AddInputAttribute(moduleDesc, formItemProps, inputprops) {
        //当下拉列表为空时显示的内容    
        if (this.state.casData.length < 1) {
            var emptyText = moduleDesc.emptyText;
            inputprops.placeholder = emptyText;
        }
        //次级菜单的展开方式，可选 'click' 和 'hover'
        var expend = moduleDesc.expandTrigger;
        inputprops.expandTrigger = expend;
        //是否支持清除
        inputprops.allowClear = moduleDesc.allowClear;

        //选择即改变
        var chgOnsel = moduleDesc.chgOnsel;
        if (chgOnsel) inputprops.changeOnSelect = 'changeOnSelect';
        //是否显示搜索框
        var search = moduleDesc.showSearch;
        if (search) inputprops.showSearch = search;
    }

    fitCasNodes1(comboBoxData) {
        var items;
        let scList = [];
        let childrenName = this.state.childrenName;
        var size = comboBoxData.length;
        for (let i = 0; i < size; i++) {
            var item = comboBoxData[i];
            if (item[childrenName] && item[childrenName].length) {
                items = this.fitCasNodes2(item[childrenName]);
                scList.push({ label: (item[this.state.displayField]), value: (item[this.state.saveField]), children: (items) });
            }
            scList.push({ label: (item[this.state.displayField]), value: (item[this.state.saveField]) });
        }
        return scList;
    };

    fitCasNodes2(comboBoxData) {
        var items;
        let scList = [];
        let childrenName = this.state.childrenName;
        var size = comboBoxData.length;
        for (let i = 0; i < size; i++) {
            var item = comboBoxData[i];
            if (item[childrenName] && item[childrenName].length) {
                items = this.fitCasNodes2(item[childrenName]);
                scList.push({ label: (item[this.state.displayField]), value: (item[this.state.saveField]), children: (items) });
            }
            scList.push({ label: (item[this.state.displayField]), value: (item[this.state.saveField]) });
        }
        return scList;
    };

    getShowValue() {
        var comboBoxData = this.state.casData;
        if (!comboBoxData) {
            return;
        }
        let value = this.state.inputprops.value;
        var newcomboBoxData = [];
        if (value && !(value instanceof Array)) {
            var valueList = value.split(",");//拆分
            for (var i = 0; i < valueList.length; i++) {
                var uceC = valueList[i];
                newcomboBoxData.push(uceC);
            }
        } else if (value) {
            newcomboBoxData = value;
        }
        let showValue = newcomboBoxData.map(key => this.getShowValueByKey(key));
        return showValue.join("/");
    }

    getShowValueByKey(key, comboBoxData) {
        if (!key) return null;
        comboBoxData = comboBoxData || this.state.casData;
        if (!comboBoxData) return null;
        for (const item of comboBoxData) {
            if (item["c"] === key) {
                return item["te"];
            } else if (item[this.state.childrenName]) {
                const sonRet = this.getShowValueByKey(key, item[this.state.childrenName]);
                if (sonRet) return sonRet;
            }
        }
    }

    //渲染并返回一个虚拟DOM
    render = function () {

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性
            this.cascader_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        // let value = this.state.inputprops.value;
        // var newcomboBoxData = [];
        // if (value) {
        //     var valueList = value.split(",");//拆分
        //     for (var i = 0; i < valueList.length; i++) {
        //         var uceC = valueList[i];
        //         newcomboBoxData.push(uceC);
        //     }
        //     this.state.showValue = newcomboBoxData;

        // } else {
        //     this.state.showValue = value;
        // }

        // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
        const { _inputProps, _formItemProps } = this.getReviseProps();
        const { isLabel } = _inputProps;

        // 渲染前通用处理，如自定义样式等
        this.renderBeforeReturn();

        let showValue = this.getShowValue();

        let value = this.state.inputprops.value;
        if (value && typeof value === "string") {
            // 某种神奇的力量会把它改成字符串，处理一下这种情况
            this.state.inputprops.value = value.split(",");
        }

        let ctl = (isLabel)
            ? <span {...this.state.inputprops} {..._inputProps} title={showValue}>{showValue}</span>
            : <Cascader {...this.state.inputprops} {..._inputProps}
                value={this.state.inputprops.value}
                options={this.fitCasNodes1(this.state.casData)} changeOnSelect />

        return this.state.noFI ? ctl : <FormItem {...this.state.formItemProps} {..._formItemProps}>{ctl}</FormItem>;
    }

    /**
     * 绑定显示值
     * @param {描述信息} currentModule
     * @param {描述信息} moduleDesc
     * @param {数据} bdInst
     * @param {对象工厂} objFct
     * @param {属性} formItem
     * @param {属性} inputprops
     */
    bindValue(currentModule, moduleDesc, bdInst, objFct, formItem, inputprops, checked) {

        if (!moduleDesc.c) {
            return;
        }

        //currentModule.bdInst = bdInst;
        var attname = moduleDesc.c;
        currentModule.state.attname = attname;

        if (!bdInst || !objFct) {
            return;
        }

        //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
        //通过type区分，type==tb时候为表格控件，其他时候为普通控件
        var bdInstValue;
        if (typeof bdInst === "string") {
            bdInstValue = objFct.get(bdInst);
        } else {
            bdInstValue = bdInst;
        }

        if (bdInstValue) {//2018.04.27-yly,有value会导致默认值无法赋值
            //给checkbox 使用
            inputprops.value = bdInstGetValue(bdInstValue, attname);
        }
        // } else {//20180704 wzhe 默认值 给当前value
        //     if (!inputprops.defaultValue) {
        //         return;
        //     }
        //     let defaultValueList = inputprops.defaultValue.split[',']
        //     inputprops.value = defaultValueList;
        //     if (bdInstValue) {
        //         // bdInstValue[attname] = inputprops.defaultValue;
        //         bdInstSetValue(bdInstValue, attname, defaultValueList);
        //     }
        // }
    }
}

let bdInstGetValue = function (bdInstValue, attname) {
    let attList = attname.split(',');
    if (attList.length == 1) {
        return (bdInstValue[attname]) ? (bdInstValue[attname].split(',')) : null;
    } else {
        let isEmpty = true;
        let values = [];
        attList.forEach(element => {
            values.push(bdInstValue[element]);
            if (bdInstValue[element]) isEmpty = false;
        });
        if (isEmpty) values = null;//如果都为空，返回null
        return values;
    }
}

let bdInstSetValue = function (bdInstValue, attname, value) {
    let attList = attname.split(',');
    if (attList.length == 1) {
        return bdInstValue[attname] = value.join(',');
    } else {
        // let attList = attname.split(',');
        // let valueList = value.split(',');
        attList.forEach((element, index) => {
            bdInstValue[element] = value[index];
        });
    }
}

//给类添加公共方法
Object.assign(SgiFormCascader.prototype, sgiFormCtlBaseFun);

//重写setValue 给refreahwv用
SgiFormCascader.prototype.setValue = function (value) {
    //更新state
    if (!value) {
        return;
    }
    this.state.inputprops.value = value;
    //页面校验
    this.validate(value);
}
//重写ctlRefresh  给change事件用
SgiFormCascader.prototype.ctlRefresh = function (attname, bdInst, objFct, value) {
    //对象工厂的值刷新
    if (bdInst && attname) {
        let bdInstData;
        if (typeof bdInst === "string") bdInstData = objFct.get(bdInst);
        else bdInstData = bdInst;
        // bdInstData[attname] = value;
        bdInstSetValue(bdInstData, attname, value);
    }
    //更新state
    this.state.inputprops.value = value;
    //页面校验
    this.validate(value);
}

export { SgiFormCascader };
export default SgiFormCascader;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiFormCascader.js